import React from 'react'
import { styled } from 'styletron-react'
import { media, sizes } from '../../style'
import { Media } from 'react-breakpoints'
import { Helmet } from 'react-helmet'

const hljs = typeof window !== 'undefined' ? window.hljs : null
const Pre = styled('pre', {
  fontSize: '16px',
  maxWidth: '860px',
  marginLeft: 'auto',
  marginRight: 'auto'
})
Pre.displayName = 'CodeBlock.Pre'

class CodeBlock extends React.Component {
  codeElement = React.createRef()
  componentDidMount() {
    this.hightlightCode()
  }
  componentDidUpdate() {
    this.hightlightCode()
  }
  hightlightCode = () => {
    hljs.highlightBlock(this.codeElement.current)
  }
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.12.0/styles/atom-one-light.min.css" />
        </Helmet>
        <Media>
          {({ breakpoints, currentBreakpoint }) => (
            <Pre>
              <code 
                ref={this.codeElement} 
                className={`language-${this.props.language}`}
                style={{
                  ...(breakpoints[currentBreakpoint] > breakpoints.tablet ? {
                    paddingTop: sizes.spacing.l,
                    paddingRight: '80px',
                    paddingBottom: sizes.spacing.l,
                    paddingLeft: '80px',
                  } : {
                    paddingTop: sizes.spacing.l,
                    paddingRight: sizes.spacing.gutter.mobile,
                    paddingBottom: sizes.spacing.l,
                    paddingLeft: sizes.spacing.gutter.mobile,
                  })
                }}
              >
                {this.props.value}
              </code>
            </Pre>
          )}
        </Media>
      </React.Fragment>
    )
  }
}
export default CodeBlock


// WEBPACK FOOTER //
// ./src/components/CodeBlock/index.js